import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { motion } from "framer-motion";

export default function ServiceCard({ service, index = 0 }) {
  return (
    <motion.article
      data-testid={`service-card-${service.slug}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
      className="group gold-ring gold-ring-hover relative flex flex-col overflow-hidden rounded-2xl bg-coal"
    >
      <Link to={`/services-luxury-spa/${service.slug}`} data-testid={`service-link-${service.slug}`} className="relative block h-60 overflow-hidden">
        <img
          src={service.image}
          alt={service.alt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-coal via-transparent to-transparent" />
        {service.special && (
          <span className="absolute left-4 top-4 rounded-full border border-gold/40 bg-obsidian/70 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold backdrop-blur">
            Signature · 60 min+
          </span>
        )}
      </Link>

      <div className="flex flex-1 flex-col gap-4 p-6">
        <div>
          <h3 className="font-serif-display text-2xl text-cream transition-colors duration-300 group-hover:text-gold-bright">
            {service.name}
          </h3>
          <p className="mt-1.5 text-sm leading-relaxed text-stone-400">{service.tagline}</p>
        </div>

        <div className="mt-auto flex items-center gap-1.5 text-xs text-stone-400">
          <Clock size={13} className="text-gold" />
          {service.durations.map((d) => d.mins).join(" / ")} min sessions
        </div>

        <Link
          to={`/services-luxury-spa/${service.slug}`}
          data-testid={`service-explore-${service.slug}`}
          className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-stone-300 transition-colors duration-300 hover:text-gold"
        >
          Explore service
          <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>
    </motion.article>
  );
}
